import { ContentSection } from './content-section.model';

export class ContentPage {
  public id?: number;
  public clinic?: number;
  public section: number;
  public name: string;
  public content: any;
  public media?: { [key: string]: { back_end: number; front_end: string; type: string }[] };
  public order?: number;
  public is_stock?: boolean;
  public is_deleted?: boolean;
  public position_after: number;

  constructor(data: any = {}) {
    this.id = data.id || void 0;
    this.clinic = data.clinic || void 0;
    this.section = data.section || void 0;
    this.name = data.name || void 0;
    this.content = data.content || void 0;
    this.media = data.media || {};
    this.is_stock = data.is_stock || void 0;
    this.is_deleted = data.is_deleted || void 0;
    this.position_after = data.position_after || void 0;
  }
}

export class ContentPagePaged {
  public count: number;
  public previous: string;
  public results: ContentPage[];
  constructor(data: any = {}) {
    this.count = data.count;
    this.previous = data.preview;
    this.results = data.results.map((item) => new ContentPage(item));
  }
}
